import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { Manager } from '../pages/';
import StaffData from '../pages/staff/StaffData';
import { NewPasswordPage } from '../components/authorization/NewPasswordPage';
import StaffCamps from '../sections/staff/StaffCamps';
import StaffSettlements from '../sections/staff/StaffSettlements';
import StaffWorkStandards from '../sections/staff/StaffWorkStandards';
import StaffPersonalDocuments from '../sections/staff/StaffPersonalDocuments';
import StaffEssentialDocuments from '../sections/staff/StaffEssentialDocuments';
import StaffAdditionalDocuments from '../sections/staff/StaffAdditionalDocuments';
import QuestionnaireFormPage from '../pages/employee/QuestionnaireFormPage';
import DocumentSigningPage from '../pages/guest/DocumentSigningPage';
import EmployeesTable from '../sections/manager/EmployeesTable';
import OrganizationalDocumentSections from '../sections/manager/OrganizationalDocumentSections';
import StaffPersonalDataProtectionDocuments from '../sections/staff/StaffPersonalDataProtectionDocuments';
import StaffOrganizingCampsInstructionDocuments from '../sections/staff/StaffOrganizingCampsInstructionDocuments';
import ManagerTemplateDocuments from '../sections/manager/ManagerTemplateDocuments';

export default () => (
  <Routes>
    <Route path="*" element={<Navigate to="/manager" />} />

    <Route path="/manager" element={<Manager />}>
      <Route path="" element={<StaffData manager={true} />}/>
      <Route path="camps" element={<StaffCamps manager={true} />}/>
      <Route path="settlements" element={<StaffSettlements manager={true} />}/>
      <Route path="personal-documents" element={<StaffPersonalDocuments manager={true} />}/>
      <Route path="work-standards" element={<StaffWorkStandards manager={true} />}/>
      <Route path="personal-data-protection-documents" element={<StaffPersonalDataProtectionDocuments manager={true} />} />
      <Route path="organizing-camps-instruction-documents" element={<StaffOrganizingCampsInstructionDocuments manager={true} />} />
      <Route path="essential-documents" element={<StaffEssentialDocuments manager={true} />}/>
      <Route path="template-documents" element={<ManagerTemplateDocuments manager={true} />}/>
      <Route path="additional-documents" element={<StaffAdditionalDocuments manager={true} />}/>
      <Route path="employees-table" element={<EmployeesTable manager={true} />}/>
      <Route path="organizational-documents" element={<OrganizationalDocumentSections />}/>
    </Route>
    <Route path="/restore-password/new-password/:uidb64/:token" element={<NewPasswordPage temporaryPasswordReset={true} />} exact />
    <Route path=":id/kwestionariusz" element={<QuestionnaireFormPage />}/>
    <Route path=":id/sign_document/:annex_nr/:model" element={<DocumentSigningPage />}/>
    <Route path=":id/sign_document/:annex_nr/:model/:module_identifier" element={<DocumentSigningPage />}/>
  </Routes>
);
